/**
 * @type {{ runtime_git_info: null | { hash, author, date, subject }[]}}
 */
export const gitInfo = { runtime_git_info: null };